<script setup lang="ts">
import img from '/@/assets/shape_3026_0.png'
const props = defineProps({
  src: {
    type: String,
    default: img // 设置默认值为空字符串
  },
  icon: {
    type: Boolean,
    default: true // 设置默认值为 false
  }
});

</script>

<template>
  <div class="back">
    <div class="title"><slot></slot></div>
    <img v-if="icon" :src="src"/>
  </div>

</template>

<style scoped lang="scss">
$box-size:2dvh;
$color1: #ffffff;
$color2:#303030;
$color3: rgba(43, 43, 43, 0);
.back {
  user-select: none;
  display: flex;
  flex-direction: row; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: center; // 让子元素左右占满
  width: 100%;
  height: 8dvh;
  background: $color1;
  box-shadow: 0 4px 7px 2px rgba(0, 0, 0, 0.6);
  img{
    width: 3.5dvh;
    transform: rotateY(180deg);
  }
}
.title{
  font-family: "wenfeng-mkzyt", sans-serif;
  font-size: 3dvh;
}
.box {
  width: 100%;
  height: $box-size;
  background: repeating-linear-gradient(
          90deg,
          $color2 0px,
          $color2 $box-size,
          $color3 $box-size,
          $color3 2*$box-size
  );
}
.box1 {
  width: 100%;
  height: $box-size;
  background: repeating-linear-gradient(
          90deg,
          $color3 0px,
          $color3 $box-size,
          $color2 $box-size,
          $color2 2*$box-size
  );
}
</style>
